<template>
  <div id="models-wrapper" ref="containerRef">
    <div
      v-if="!contentLoaded || loading"
      :class="[
        gridType === 'small'
          ? 'models-grid models-grid--skeleton mb-9'
          : 'models-grid models-grid--skeleton models-grid--big mb-9',
      ]"
    >
      <div
        class="model-card_wrapper model-card_wrapper--skeleton"
        v-for="item in 24"
        :key="item"
      />
    </div>
    <div
      v-else-if="models.length !== 0 && type === 'one'"
      class="mb-9 models-grid"
      :class="{ 'models-grid--big': gridType === 'big' }"
    >
      <bim-product-card
        v-for="model in models['models']"
        :key="model.id"
        v-bind="formModelData(model, gridType === 'small' ? 'card' : 'wide')"
        :type="gridType === 'small' ? 'card' : 'wide'"
        width="100%"
        itemscope
        itemtype="http://schema.org/ImageObject"
        class="mb-0"
      />
    </div>

    <!--модели-->
    <div v-else-if="models.group.length" :key="reMounted">
      <div :class="{ 'models-grid--big': gridType === 'big' }">
        <div
          v-for="(line, rowIndex) in models.group"
          :key="`row-${rowIndex}`"
          class="d-flex my-2"
        >
            <div
            v-for="(itemLine, index) in line"
            :key="`company-${index}`"
            class="d-flex flex-column card-base"
          >
            <span class="company-name">
              {{ itemLine.companyName | truncate(15) }}
            </span>
            <div class="d-flex card-row">
              <bim-product-card
                v-for="model in itemLine.models"
                :key="model.id"
                class="card-sizes"
                v-bind="formModelData(model, gridType === 'small' ? 'card' : 'wide')"
                :type="gridType === 'small' ? 'card' : 'wide'"
                target="_blank"
                :style="`min-width: ${getProductWidth(line)}px;`"
                itemscope
                itemtype="http://schema.org/ImageObject"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <bim-pagination
      :totalPages="totalPages"
      :activePage="page"
      @changePage="whatPage"
      scroll-to=".models-header"
    />

    <div
      v-if="(models.length === 0 || models.group.length === 0) && showNotFound && !loading"
      class="col-xxl-10 col-12 d-flex flex-column align-center mx-auto py-md-12 not-found pt-0"
    >
      <p class="notfound-title mb-md-9 mb-6">{{ $t("Подходящих моделей не найдено") }}</p>
      <p class="notfound-subtitle mb-9">Попробуйте поиск без фильтров</p>
      <bim-button
        width="200"
        color="gray"
        @click="resetFilter()"
        :label="`Очистить фильтры (${counterFilterTags})`"
        size="l"
      ></bim-button>

      <!--<addsearch v-show="showModal === 'addsearch'" @close="showModal = 'closed'"></addsearch>-->
    </div>
  </div>
</template>

<script>
// import addsearch from '../../athoms/Megasearch/AddSearchModal'

import bimProductCard from "@bimlib/components/bimProductCard";
import bimPagination from "@bimlib/components/bimPagination";
import {mapGetters, mapActions, mapMutations} from "vuex";
import FormModelCardDataMixin from "@/mixins/models/form-model-card-data";
import { cloneDeep } from 'lodash';

export default {
  mixins: [FormModelCardDataMixin],
  components: { bimProductCard, bimPagination },
  mounted() {
    const onChangeContainerSize = () => {
      ++this.reMounted;
    };
    new ResizeObserver(onChangeContainerSize).observe(this.$refs.containerRef);
  },
  data() {
    return {
      // showModal: 'closed',
      showNotFound: false,
      page: 1,
      reMounted: 0,
      type: "six",
    };
  },
  computed: {
    ...mapGetters([
      "totalPages",
      "totalModels",
      "totalAllModels",
      "contentLoaded",
      "counterFilterTags",
      "gridType",
      "modelsData",
      "groupedModels",
      "currentPage",
    ]),
    ...mapGetters({
      loading: "getLoading",
    }),
    models() {
      let numberItemsInLine = 6

      if (1280 < this.ww && this.ww < 1304) {
        this.type = 'five'
        numberItemsInLine = 5
      } else if (670 < this.ww && this.ww < 1280) {
        this.type = 'four'
        numberItemsInLine = 4
      } else if (470 < this.ww && this.ww < 670) {
        this.type = 'three'
        numberItemsInLine = 3
      } else if (this.ww < 470) {
        this.type = 'one'
        numberItemsInLine = 1
      } else {
        this.type = 'six'
        numberItemsInLine = 6
      }

      const models = { models: this.modelsData, group: [] };

      models.group = Object.entries(cloneDeep(this.groupedModels)).reduce(
        (array, [companyName, models]) => {
          if (!models?.length) return array

          if (array.length === 0) {
            array.push([
              { companyName, models: models.splice(0, numberItemsInLine) },
            ])
          }

          if (models?.length !== 0) handlerRows(array, models, companyName)

          return array
        },
        []
      )

      function handlerRows(array, models, companyName) {
        const lastLine = array[array.length - 1]
        const numberModelsInLine = lastLine.reduce(
          (number, item) => number + item.models.length,
          0
        )

        if (numberModelsInLine === numberItemsInLine) {
          array.push([{ companyName, models: models.splice(0, numberItemsInLine) }])
        } else {
          const remainder = numberItemsInLine - numberModelsInLine
          lastLine.push({ companyName, models: models.splice(0, remainder) })
        }

        if (models?.length !== 0) handlerRows(array, models, companyName)
      }

      this.page = +this.currentPage;

      if (this.contentLoaded) this.showNotFound = true;

      return models;
    },
  },
  methods: {
    ...mapMutations([
      'setCards',
    ]),
    ...mapActions(["resetFilter"]),
    async whatPage(page) {
      this.page = page;
      await this.$store.dispatch("setPage", this.page);
    },
    getProductWidth(rowItems) {
      const companyArray = Object.values(rowItems);
      const countCompanies = companyArray.length;
      const countProducts = companyArray.reduce(
        (count, { models }) => count + Object.keys(models).length,
        0
      );
      return (
        (this.$refs.containerRef.offsetWidth - // ширина контейнера
          2 * (countCompanies - 1) - // отступы между компаниями за исключением первой
          2 * countProducts - // лишний ширина от кол-во продуктов, хз почему взялось
          8 * countProducts + // отступы между продуктами (по 4 пикселя с каждой стороны)
          4 * countCompanies) / // добираем остатки отступов, т.к. у первого и последнего продукта отступы меньше
        countProducts
      );
    },
    firstEl(model){
      let tariff = ''
     try{
       tariff =  Object.values(model)[0][0].tariff;
     }catch (ex){
       tariff = '';
     }
     return tariff;
    }
  },
  filters: {
    truncate: function (data, num) {
      const reqdString = data.split("").slice(0, num).join("");
      return data.length > num ? `${reqdString}...` : reqdString;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./src/front_white/sass/components/settings";

.company-name {
  padding: 8px 2px 6px 8px;
  font-size: 12px;
  font-weight: 500;
}

.card-base {
  background: #efefef;
  border-radius: 10px;
  padding-top: 2px;
  padding-bottom: 2px;
}

.card-base + .card-base {
  margin-left: 2px;
}
.card-vip {
  background: #FFF2DE !important;
}


.card-sizes {
  margin-right: 4px;
}

.card-sizes + .card-sizes {
  margin-left: 4px;
}

.card-sizes:first-child {
  margin-left: 2px;
}

.card-sizes:last-child {
  margin-right: 2px;
}

.notfound-title {
  font-size: 32px;
  font-weight: bold;
}

.notfound-subtitle {
  font-size: 18px;
}

// .model-card_wrapper {
//   max-width: 16.66666666667%;
//   width: 16.66666666667%;
//   padding-right: $col-gap-xxl;
//   padding-left: $col-gap-xxl;
//   @media screen and (max-width: $breakpoint-xxl) {
//     max-width: 20%;
//     width: 20%;
//     padding-right: $col-gap-xl;
//     padding-left: $col-gap-xl;
//   }
//   @media (min-width: $breakpoint-xs) and (max-width: width-max($breakpoint-sm)) {
//     max-width: 50%;
//     width: 50%;
//     padding-right: $col-gap-xs;
//     padding-left: $col-gap-xs;
//   }
//   &--big {
//     max-width: 33.33333333333333%;
//     width: 33.33333333333333%;
//     @media screen and (max-width: 1440px) {
//       max-width: 40%;
//       width: 40%;
//     }
//     @media (min-width: $breakpoint-xs) and (max-width: width-max($breakpoint-sm)) {
//       max-width: 100%;
//       width: 100%;
//       padding-right: $col-gap-xs;
//       padding-left: $col-gap-xs;
//       margin-bottom: 12px;
//     }
//   }
//   &_filter-closed {
//     @media screen and (max-width: 1440px) {
//       max-width: 16.66666666667%;
//       width: 16.66666666667%;
//     }
//     @media (min-width: $breakpoint-xs) and (max-width: width-max($breakpoint-md)) {
//       max-width: 50%;
//       width: 50%;
//     }
//     &--big {
//       // @media screen and (max-width: 1440px) {
//       max-width: 33.33333333333333%;
//       width: 33.33333333333333%;
//       @media (min-width: $breakpoint-xs) and (max-width: width-max($breakpoint-sm)) {
//         max-width: 100%;
//         width: 100%;
//         padding-right: $col-gap-xs;
//         padding-left: $col-gap-xs;
//         margin-bottom: 12px !important;
//       }
//       // }
//     }
//   }
// }
// .model-card {
//   padding-bottom: 0;
//   height: unset;
//   width: calc(100% + 16px);
//   height: 18.7333rem;
//   @media (min-width: $breakpoint-xs) and (max-width: width-max($breakpoint-md)) {
//     width: 100%;
//     min-width: 100%;
//     max-height: 240px;
//   }
// }
.show-more_btn {
  width: 10.4rem;
  height: 2.9333rem;
  background-color: $active-superlight;
}

// Пагинация
// .pagination__wrapper {
//   padding-bottom: 0.0667rem;
// }
// .page__number,
// .dots {
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   width: 2.7333rem;
//   height: 2.8667rem;
//   -webkit-touch-callout: none; /* iOS Safari */
//   -webkit-user-select: none; /* Chrome/Safari/Opera */
//   -khtml-user-select: none; /* Konqueror */
//   -moz-user-select: none; /* Firefox */
//   -ms-user-select: none; /* Internet Explorer/Edge */
//   user-select: none;
// }
// .dots {
//   cursor: default;
// }
// .page__number {
//   cursor: pointer;
//   margin-right: 0.0667rem;
//   box-shadow: 0 0 0 0.0667rem $text-soft-light;
//   z-index: 1;
//   &:hover {
//     z-index: 2;
//     box-shadow: 0 0 0 0.0667rem $text-soft-dark;
//   }
//   &:active {
//     box-shadow: 0 0 0 0.0667rem $text-soft-dark;
//     background-color: $soft;
//   }
//   &--active {
//     cursor: default;
//     z-index: 3;
//     box-shadow: 0 0 0 0.0667rem $active;
//     &:hover {
//       box-shadow: 0 0 0 0.0667rem $active;
//     }
//     &:active {
//       box-shadow: 0 0 0 0.0667rem $active;
//     }
//   }
// }
// .pagination__arrow {
//   width: 6.4667rem;
//   .icon-arrow-left {
//     color: $text-main;
//     fill: $text-main;
//     -webkit-text-fill-color: $text-main;
//   }
// }
// .arrow__next {
//   border-radius: 0 0.3333rem 0.3333rem 0;
//   .icon-arrow-left {
//     transform: rotate(180deg);
//     margin-left: 0.5333rem;
//   }
// }
// .arrow__prev {
//   border-radius: 0.3333rem 0 0 0.3333rem;
//   .icon-arrow-left {
//     margin-right: 0.5333rem;
//   }
// }
// .disabled {
//   cursor: not-allowed;
//   opacity: 0.3;
//   &:hover {
//     box-shadow: 0 0 0 0.0667rem $text-soft-light;
//   }
//   &:active {
//     box-shadow: 0 0 0 0.0667rem $text-soft-dark;
//     background-color: unset;
//   }
// }
</style>
